import { render, staticRenderFns } from "./MemberListTopCuratorLayout.vue?vue&type=template&id=6ce70082&scoped=true&"
import script from "./MemberListTopCuratorLayout.vue?vue&type=script&lang=js&"
export * from "./MemberListTopCuratorLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ce70082",
  null
  
)

export default component.exports